// src/components/Icon.js
import React from 'react';

// Cargar componentes React de iconos generados
const req = require.context('../../images/iconComponents', false, /\.js$/);

const icons = req.keys().reduce((acc, path) => {
  const name = path.replace('./', '').replace('.js', '');
  acc[name] = req(path).default;
  return acc;
}, {});

export default function Icon({ name, size = 24, color = 'currentColor', className = '', ...props }) {
  const SvgIcon = icons[name];
  if (!SvgIcon) {
    console.warn(`Icon "${name}" no encontrado.`);
    return null;
  }

  return (
    <SvgIcon
    className={`w-[${size}px] h-[${size}px] ${className}`}
      width={size}
      height={size}
      fill={color}
      {...props}
    />
  );
}
